import { ForwardedRef, forwardRef } from "react";
import Responsable from "../../../Responsable";
import BaseSection from "../../BaseSection";
import { colorV2 } from "../../../../constants/styles";
import ScrollOverlayContact from "../scrollOverays/ScrollOverlayContact";

const PluugSection = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <BaseSection fullWidth ref={ref} id="pluug-section">
      <Responsable
        widthFull
        backgroundColor={colorV2.GRAY_01}
        pc={<ScrollOverlayContact />}
        tablet={<ScrollOverlayContact />}
        mobile={<ScrollOverlayContact />}
      />
    </BaseSection>
  );
});

export default PluugSection;
